import styled from 'styled-components';
import { H2, paragraph, spacedHeading } from '../../../../theme/typography';
import { themeColor, themeSize } from '../../../../theme/getters';
import { media } from '../../../../theme/media';

export const Container = styled.div`
  margin-bottom: 56px;
  max-width: 700px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  ${media.tablet`
    padding: 0 32px;
  `};
`;

export const Title = styled(H2)`
  ${spacedHeading};
  margin-bottom: ${themeSize('contentVerticalMargin')}px;
`;

export const Disclaimer = styled.p`
  ${paragraph};
  color: ${themeColor('gray')};
  text-align: left;
  margin-top: 23px;
`;
